import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class UniversalStorageService {
  constructor(@Inject(PLATFORM_ID) private platformId) {}

  setItem(key: string, value): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, value);
    }
  }

  getItem(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      const storedValue = localStorage.getItem(key);
      return storedValue ? storedValue : null;
    }
    return null;
  }
  removeItem(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(key);
    }
  }
  getDefaultLanguage(): string {
    if (isPlatformBrowser(this.platformId)) {
      const storedLanguage = localStorage.getItem('language');
      if (storedLanguage) {
        return storedLanguage;
      }
    }

    // If not in the browser or no language is stored, return your default language here.
    return 'en-GB'; // You can set your desired default language.
  }
}
